import styled from 'styled-components';
import { theme, minBp } from '@triumph/shared';

export const Wrap = styled.div`
  padding: 55px 30px 30px;

  @media ${minBp('tablet')} {
    padding: 75px 60px 60px;
    width: 600px;
  }

  @media ${minBp('tabletLarge')} {
    width: 800px;
  }
`;

export const Title = styled.h3`
  margin-bottom: 8px;
  text-transform: uppercase;
`;

export const Description = styled.div`
  p {
    font-size: 16px;
    margin-bottom: 0;
  }
`;
